export default {
    intro: `지문을 잘 살펴보고, 퀴즈냥의 문제를 풀어 보세요.<br/>
            다 풀면 맛있는 간식이 기다려요!`,
    correct: '정답',
    incorrect: '오답',
    next: '다음',
    greetings: [
        '냐옹! 퀴즈냥이다냥. 오늘은 지문을 읽고 이야기를 해보자냥.',
        '냐옹! 난 퀴즈냥이다냥. 글을 읽고 중요한 내용을 찾아보자냥.',
        '냐옹! 퀴즈냥이다냥. 지문을 읽고 퀴즈를 맞춰봐라냥.',
        '냐옹! 내 이름은 퀴즈냥이다냥. 내가 내는 퀴즈를 맞춰봐라냥.',
        '냐옹! 퀴즈냥 등장이다냥. 나랑 같이 퀴즈 맞추러 가보자냥.',
    ],
    reactions: [
        '이해됐어요! 다음 문제도 풀어볼게요.',
        '설명을 들으니 확실히 알겠어요.',
        '다음 문제도 풀어보고 싶어요!',
        '설명 덕분에 감이 잡혔어요. 계속 진행해 볼게요.',
        '생각보다 어렵지 않았네요.',
    ],
    finalReactions: [
        '드디어 다 맞췄네요! 이제 뭐 먹을 수 있나요?',
        '문제 다 풀었어요! 음식 고를 수 있어서 기대돼요.',
        '빨리 뭘 먹을지 고르고 싶어요.',
        '열심히 했더니 배고파졌어요. 뭐가 좋을까요?',
        '두근두근. (뭘 먹을지 상상하며)',
    ],
    snackReactions: ['다 풀었다니 제법이다냥. 먹고 싶은 간식 하나 골라보라냥.'],
};
